// @ts-nocheck
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import cloneDeep from "lodash/cloneDeep";

addToChainAfter(chain, PopulateApiParameter, props => {
    const { firstName, languageId, lastName } = props.getState().bunzl.pages.accountSettings;
    const accountCopy = cloneDeep(props.apiParameter.account);
    if (firstName) {
        accountCopy.firstName = firstName;
    }
    if (languageId) {
        accountCopy.properties.languageId = languageId;
    }
    if (lastName) {
        accountCopy.lastName = lastName;
    }
    props.apiParameter.account = accountCopy;
});
